import React, { useEffect, useState } from "react";
import { Box, Avatar, Typography, IconButton } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { useApp } from "../../Context/AppContext";

const UserProfile = (props) => {
  const { setUserProfileData, isEditing } = props;
  const { user: data, setUser: setData } = useApp({});
  const [profileImage, setProfileImage] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      setData(userData);
    }
  }, []);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUserProfileData({
        ...data,
        profile_image: file,
      });
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImage(reader.result); // Update the profile image with the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };

  if (!data) {
    return null;
  }

  return (
    <Box
      sx={{
        fontSize: { xs: "16px", sm: "17px", md: "18px" },
        display: { xs: "block", sm: "block", md: "flex" },
        flexDirection: "row",
        alignItems: "center",
        gap: 5,
        textAlign: { xs: "center", sm: "center", md: "left" },
      }}
    >
      {/* Left Column: Profile Image */}
      <Box position="relative">
        <Avatar
          alt="User Profile"
          src={profileImage ? profileImage : data?.profilePic} // Dynamic profile image
          sx={{
            width: 145,
            height: 145,
            border: "3px solid #ddd",
            margin: { xs: "0 auto", sm: "0 auto", md: "0 auto" },
          }}
        />
        {isEditing && (
          <IconButton
            component="label"
            sx={{
              position: "absolute",
              bottom: 0,
              right: 0,
              backgroundColor: "white",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          >
            <PhotoCameraIcon fontSize="small" />
            {/* Hidden file input for image upload */}
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => {
                handleImageChange(e);
              }}
            />
          </IconButton>
        )}
      </Box>

      {/* Right Column: User Info */}
      <Box className="profileInfoColumn">
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: { xs: "18px", sm: "20px", md: "23px" } }}
        >
          {data.fullName}
        </Typography>
        <Typography className="username" variant="body2" color="text.secondary">
          {data.username}
        </Typography>
        <Typography className="companyName" variant="body1" mt={1}>
          {data.company}
        </Typography>
        {/* <Typography
          className="shortBio"
          variant="body2"
          mt={1}
          color="text.secondary"
        >
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s. Lorem Ipsum has been the industry's.
        </Typography> */}
      </Box>
    </Box>
  );
};

export default UserProfile;
